/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import devConfig from './config.dev';
import localConfig from './config.local';
import prodConfig from './config.prod';
import qaConfig from './config.qa';
import uatConfig from './config.uat';

import { Environments } from '@/lib/constants';
import { ServerConfig } from '@/types/app-config';

let envConfigMap: Record<Environments, ServerConfig> | object = {};
if (typeof window === 'undefined') {
  envConfigMap = {
    local: localConfig,
    dev: devConfig,
    qa: qaConfig,
    uat: uatConfig,
    prod: prodConfig,
  };
}

export default envConfigMap;
